var map = {
	"./antinut.png": "9c27",
	"./bug.png": "9f3c",
	"./employees.png": "7cb4",
	"./employees1.png": "079c",
	"./files.png": "2c17",
	"./fridge.png": "82cc",
	"./handwash.png": "2df6",
	"./icon_arrows-1.png": "3aa3",
	"./icon_cleaning-1.png": "20e7",
	"./icon_desk-1.png": "c62a",
	"./icon_sink-1.png": "4b16",
	"./measure.png": "4a56",
	"./notebook.png": "b3b4",
	"./snowflake.png": "9262",
	"./spray.png": "cd7d",
	"./table.png": "740b",
	"./traffic.png": "f085",
	"./trash.png": "49c1",
	"./utensils.png": "7eee"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f236";